import { Component } from '@angular/core';
import { LocalStorageService } from '@services/local-storage.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { CustomerService } from '@common/services/customer-service';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    templateUrl: './view.html',
    styles: [`
        :host {
            height: 100%;
            display: flex;
            flex-flow: column;
        }
        .logo {
            max-width: 350px;
        }
    `],
    standalone: true,
    imports: [
        CommonModule,
        RouterModule,
        TranslateModule
    ]
})

export class PublicLayoutComponent {
    logo: SafeResourceUrl;
    isDefaultBrand = true;

    constructor(
        private localStorageService: LocalStorageService,
        private customerService: CustomerService,
        private sanitizer: DomSanitizer) {
        this.customerService.logo.subscribe(({logoUrl, ...colors}) => {
            if (logoUrl){
                this.isDefaultBrand = false;
                this.sanitizeLogo(logoUrl);
                this.setupColors(colors);
            } else {
                this.isDefaultBrand = true;
            }
        });
    }

    sanitizeLogo(logo) {
        this.logo = this.sanitizer.bypassSecurityTrustResourceUrl(logo);
    }

    setupColors(colors) {
        document.documentElement.style.setProperty('--base-green', colors.mainColor);
        document.documentElement.style.setProperty('--base-white', colors.bgColor);
        document.documentElement.style.setProperty('--base-blue', colors.firstAddColor);
        document.documentElement.style.setProperty('--content-bg', colors.secondAddColor);
    }

}
